import { ResourceMetadata } from '@esg/esg-global-types';

/**
 * Given a list of company level resource metadata items, fetch the one corresponding to a given master list resource if exists.
 * @param {string} resource_id ID of master list resource to match to metadata item.
 * @param {Array<ResourceMetadata>} resources_metadata List of company level resource metadata items to search through.
 * @returns {ResourceMetadata | null}
 */
export const getMetadataForResource = (
  resource_id: string,
  resources_metadata: Array<ResourceMetadata>
): ResourceMetadata | null => {
  return (
    resources_metadata.find(
      (resource_metadata: ResourceMetadata) =>
        resource_metadata.master_list_resource.id === resource_id
    ) ?? null
  );
};
